<div class="assistant-thread" #thread>
    @if (messages.length === 0 && !sending) {
    <div class="assistant-empty">
        <p>Ask a question about your data.</p>
        <div class="assistant-suggestions">
            @for (suggestion of suggestions; track suggestion) {
            <button class="assistant-suggestion" (click)="askSuggestion(suggestion)">{{ suggestion }}</button>
            }
        </div>
    </div>
    } @for (message of messages; track message; let last = $last) {
    <div class="assistant-message" [class.from-user]="message.role === 'user'" [class.is-error]="message.error">
        @if (message.html) {
        <div class="assistant-bubble assistant-markdown" [innerHTML]="message.html"></div>
        } @else {
        <div class="assistant-bubble">{{ message.content }}</div>
        }
        @if (message.citations?.length) {
        <div class="assistant-citations">
            @for (citation of message.citations; track citation.id) {
            <button class="assistant-citation" (click)="openCitation(citation)">#{{ citation.nbr }}</button>
            }
        </div>
        } @if (message.toolCalls?.length) {
        <div class="assistant-trace">{{ toolTrace(message) }}</div>
        } @if (message.error && last && canRetry) {
        <button class="assistant-retry" (click)="retry()">Retry</button>
        }
    </div>
    } @if (sending) {
    <div class="assistant-message">
        <div class="assistant-bubble assistant-typing"><span class="dot"></span><span class="dot"></span><span class="dot"></span></div>
    </div>
    }
</div>
<div class="assistant-composer">
    <textarea
        class="sw-textarea"
        placeholder="Ask a question..."
        [(ngModel)]="question"
        [disabled]="sending"
        rows="2"
        (keydown.enter)="onEnter($event)"
    ></textarea>
    <button class="sw-btn sw-btn-primary sw-btn-sm" (click)="send()" [disabled]="!isValid || sending">{{ sending ? 'Sending...' : 'Send' }}</button>
</div>
